'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createtDictionaryGetter;
function createtDictionaryGetter(obj) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return function dictionaryGetter(prop) {
        if (obj[prop] === undefined) {
            throw new Error(error + ' -> ' + prop);
        }
        return obj[prop];
    };
}
//# sourceMappingURL=dictionary.js.map